export const selectIsDrawerOpen = state => state.app.drawerOpen;
export const selectAppTitle = state => state.app.appTitle;
export const selectUsername = state => state.app.username;
export const selectAppDecimal = state => state.app.appDecimal;
export const selectBandedRows = state => state.app.bandedRows;
export const selectDisplayMajorsAndMinorsOnTitle= state => state.app.displayMajorMinorOnTitle;
export const selectGridVerticalLines = state => state.app.gridVerticalLines;
export const selectGridFontSize = state => state.app.gridFontSize;
export const selectGridRowHeight = state => state.app.gridRowHeight;
export const selectHideGridSideBar = state => state.app.hideGridSideBar;
export const selectNoAccountFlag = (state) => state.app.noAccountLoad;